import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react"
import AppToast from "components/Toast"

const ToastContext = createContext(null)

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null)

  const showToast = useCallback(({ message, severity = "info", duration }) => {
    setToast({ message, severity, duration })
  }, [])

  const hideToast = useCallback(() => {
    setToast(null)
  }, [])

  const showSuccess = useCallback(
    (message, otherProps = {}) => showToast({ message, severity: "success", ...otherProps }),
    [showToast]
  )

  const showError = useCallback(
    (message, otherProps = {}) => showToast({ message, severity: "error", ...otherProps }),
    [showToast]
  )

  const value = useMemo(
    () => ({ showToast, hideToast, showSuccess, showError }),
    [showToast, hideToast, showSuccess, showError]
  )

  return (
    <ToastContext.Provider value={value}>
      {children}
      <AppToast
        toast={toast}
        onClose={hideToast}
        autoHideDuration={toast?.duration}
      />
    </ToastContext.Provider>
  )
}

export function useToast() {
  const ctx = useContext(ToastContext)
  if (!ctx) {
    throw new Error("useToast must be used within ToastProvider")
  }
  return ctx
}
